// Meta Pixel (client-side, no secrets — the pixel ID is public by design).
export const META_PIXEL_ID = "1050235434454170";

// Official Meta Pixel bootstrap. Loads fbevents.js, initializes once, and
// fires the initial PageView. Subsequent SPA route changes are tracked by
// the router subscriber in MetaPixelTracker (src/components/MetaPixelTracker.tsx).
export const META_PIXEL_BOOTSTRAP = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');`;

export const META_PIXEL_NOSCRIPT_SRC = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

/** Fire a PageView for a client-side route change. No-op off-browser or before the bootstrap loads (the bootstrap queues calls made early, so this is safe either way). */
export function trackMetaPageView(): void {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
}

/**
 * Fire a standard Meta Pixel event (Purchase, Lead, …).
 * Never pass customer PII in `params`.
 */
export function trackMetaEvent(
  name: string,
  params?: Record<string, unknown>,
  options?: { eventID?: string },
): void {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;
  if (options?.eventID) {
    window.fbq("track", name, params ?? {}, { eventID: options.eventID });
  } else {
    window.fbq("track", name, params ?? {});
  }
}
